import { styled } from '@clickcease/cc-client-components-lib'

export const UpdatePasswordStyled = styled('div', {
  width: '455px',
  height: '368px',
  background: '#FFFFFF',
  padding: '26px 24px',
})

export const UpdatePasswordDescription = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '20px',
})
